import { Moment } from 'moment'

export const gasConsumptionItemKey = 'YYYYMMDDHHmm'

type Item = { [YYYYMMDDHHmm: string]: number }

export type GasConsumptionData = {
  currentGasConsumption: number
  co2Emission: number
  items: Item
}

export default class Consumption {
  declare currentGasConsumption: number
  declare co2Emission: number
  declare items: Item

  constructor(params: GasConsumptionData) {
    Object.assign(this, params)
  }

  getItem(date: Moment): number | null {
    return this.items[date.format(gasConsumptionItemKey)] ?? null
  }
}
